import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export function AuthCard({ title, subtitle, children }: { title: ReactNode; subtitle?: ReactNode; children: ReactNode }) {
  const { t } = useTranslation('common');
  return (
    <div className="k-auth">
      <div className="k-auth__card">
        <div>
          <div className="k-auth__brand">{t('appName')}</div>
          <h1 className="k-panel-title" style={{ marginTop: 16 }}>{title}</h1>
          {subtitle && <p className="k-muted" style={{ margin: '6px 0 0' }}>{subtitle}</p>}
        </div>
        {children}
      </div>
    </div>
  );
}
